<!--
component: MapPane
author: Ken Nakamura
description: 地図検索画面
-->
<template>
  <section class="address">
    <div class="head-message">
      地番を入力して下さい
    </div>
    <v-container>
      <v-row class="py-1">
        <v-col md7 sm12>
          <v-container>
            <v-row>
              <v-col cols="4" xs="4" sm="3" class="text-center" align-self="center">
                <label for="text-oyaban"
                  style="font-size: 1.4em;">
                  親番
                </label>
              </v-col>
              <v-col>
                <v-text-field id="text-oyaban" v-model="oyaban" ref="oyaban"
                  solo autocomplete="off" hide-details="auto"
                  type="tel" hide-spin-buttons
                  @focus="selectEdaban(false)"
                  @keyup="checkChar"
                  @keydown.enter="focusEdaban"
                  :background-color="oyabanColor" class="text-h5"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" xs="4" sm="3" class="text-center" align-self="center">
                <label for="text-edaban" style="font-size: 1.4em;">
                  枝番
                </label>
              </v-col>
              <v-col>
                <v-text-field id="text-edaban" v-model="edaban" ref="edaban"
                  solo autocomplete="off" hide-details="auto"
                  type="tel" hide-spin-buttons
                  @focus="selectEdaban(true)"
                  :background-color="edabanColor" class="text-h5"
                />
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-btn color="#6b3f16" height="1.6em"
                @click="gotoAddrList"
                class="search-btn"
                :class="['xs'].includes($vuetify.breakpoint.name) ? 'text-h5' : ''"
                :style="['xs'].includes($vuetify.breakpoint.name) ? 'width:80%' : ''"
                :loading="loadingList"
                :disabled="loadingMap || loadingList || (mode==1 && !oyabanSpecified)"
              >検索</v-btn>
            </v-row>
          </v-container>
        </v-col>
        <v-col v-show="!['xs'].includes($vuetify.breakpoint.name)">
          <TenkeyPad @pushed="tenkeyPushed" @clear="tenkeyClear" />
        </v-col>
      </v-row>
    </v-container>
    <!--
    <h1 style="margin: 0.5em 0 0; text-align: center;">【付近の地図を表示】ボタンを押すと地図検索画面に移行できます。</h1>
    -->
    <!-- 検索中ダイアログ -->
    <v-dialog id="searchlodingDialog" :width="dialogBkPoint" v-model="searchDialog" persistent>
      <v-card>
        <v-card-title class="text-h6 px-5">
          <v-icon large color="primary">mdi-database-search</v-icon>&nbsp;検索中
        </v-card-title>
        <v-card-text class="pb-0">
          <v-progress-linear
            color="light-blue darken-2"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cancelSearch()">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- メッセージダイアログ -->
    <v-dialog id="dialog" :width="dialogBkPoint" v-model="dialog" persistent>
      <v-card>
        <v-card-title>検索</v-card-title>
        <v-card-text class="pa-0">
          <v-row align="center" class="ma-1">
            <v-col cols="2" class="pa-0" align="center">
              <v-icon large color="error" class="ma-auto" v-if="dialogCategory == 1">mdi-alert</v-icon>
              <v-icon large color="success" class="ma-auto" v-else-if="dialogCategory == 0">mdi-check-circle</v-icon>
            </v-col>
            <v-col cols="10">{{ dialogMsg }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-1">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
		<Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
      title="ユーザー認証" body="ユーザー認証に失敗しました。ログインし直して下さい。"/>
  </section>
</template>

<script>
import TenkeyPad from '../components/TenkeyPad.vue'
import { dbglog, chibanURL } from '../common/utils'
import { searchGaiyoByAddress } from '../common/apiAccess'
import Dialog from '../components/Dialog.vue'

export default {
  components: {
    TenkeyPad,
    Dialog,
  },
  data: () => {
    return {
      oyaban: '',
      edaban: '',
      edabanActive: false,
      loadingMap: false,
      loadingList: false,
      // 検索中フラグ
      searchDialog: false,
      dialog: false,
      dialogCategory: 0, // 0:正常(success),1:異常(error)
      dialogMsg: '',
      // API中断用コントローラ
      controller: null,
      authDialog: false,
    }
  },
  props: {
  },
  watch: {
    oyaban: {
      immediate: true,
      handler(val) {
        if (val) {
          val = parseInt(val);
          if (Number.isNaN(val) || val <= 0) {
            val = '';
          }
          this.$refs.oyaban.lazyValue = val;
          this.oyaban = val;
        }
      }
    },
    edaban: {
      immediate: true,
      handler(val) {
        if (val) {
          val = parseInt(val);
          if (Number.isNaN(val) || val <= 0) {
            val = '';
          }
          this.$refs.edaban.lazyValue = val;
          this.edaban = val;
        }
      }
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.loadingMap = false;
    this.loadingList = false;
    this.$store.commit('setCurrentPage', 4);
    this.oyaban = this.$store.state.oyaban == 0 ? '' : this.$store.state.oyaban;
    this.edaban = this.$store.state.edaban == 0 ? '' : this.$store.state.edaban;
    this.$store.commit('setFeatures', []);
    this.$store.commit('setSelectedNo', null);
    this.setMessage();
    this.$refs.oyaban.focus();
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    mode() {
      return this.$store.state.mode;
    },
    addrBtnVisible() {
      return this.mode == 1 || this.mode == 2 || this.mode == 3 || this.mode == 7;
    },
    oyabanSpecified() {
      return this.oyaban != "" && this.oyaban > 0;
    },
    oyabanColor() {
      return this.edabanActive ? '#eeeeee' : '#ffffcc'
    },
    edabanColor() {
      return this.edabanActive ? '#ffffcc' : '#eeeeee'
    },
    isTouch() {
      //ToDo: タッチパネルかどうか動的に判断
      //return this.$store.state.platform == 'Touch';
      return true;
    },
    wardCode() {
      return this.$store.state.wardCode;
    },
    wardName() {
      return this.$store.state.wardName;
    },
    townCode() {
      return this.$store.state.townCode;
    },
    townName() {
      return this.$store.state.townName;
    },
    searchButtonCaption() {
      if (this.mode == 1 || this.mode == 4 || this.mode == 5 || this.mode == 6) {
        return '検索';
      }
      else if(this.mode == 7) {
        return '地番で検索';
      }
      else {
        return '住所で検索';
      }
    },
    // ブレークポイント(端末のサイズ・画面サイズ)によって部品のサイズを動的に変える
		dialogBkPoint () {
			switch( this.$vuetify.breakpoint.name) {
				case 'xl':
					return '30%';
				case 'lg':
					return '30%';
				case 'md':
					return '50%';
				case 'sm':
					return '90%';
				case 'xs':
					return '90%';
				default:
					return '30%';
			}
		},
  },
  methods: {
    /**
     * AppFooterに表示するメッセージを生成・登録
     */
    setMessage () {
      let addrText = `${this.wardName} ${this.townName}`;
      if (this.oyaban > 0) {
        addrText += ` ${this.oyaban}`;
        if (this.edaban > 0) {
          addrText += `-${this.edaban}`;
        }
      }
      this.message = `地名・地番検索：${addrText}`;
    },
    /**
     * テンキーボタンが押された時の処理
     * @param {Number} val 押されたキーの数値
     */
    tenkeyPushed (val) {
      if (this.edabanActive) {
        this.edaban = this.edaban * 10 + val;
      }
      else {
        this.oyaban = this.oyaban * 10 + val;
      }
      this.setMessage();
    },
    /**
     * クリアボタンが押された時の処理
     */
    tenkeyClear () {
      if (this.edabanActive) {
        this.edaban = '';
      }
      else {
        this.oyaban = '';
      }
      this.setMessage();
    },
    focusEdaban () {
      this.$refs.edaban.focus();
    },
    checkChar () {
      /*
      if (this.edabanActive && this.edaban) {
        this.edaban = this.edaban.replace(/[^0-9]/g, '');
      }
      else if (this.oyaban) {
        this.oyaban = this.oyaban.replace(/[^0-9]/g, '');
      }
      */
    },
    /**
     * 位置情報を知るために指定された地番を検索する
     * @param {Number} ward 区コード
     * @param {Number} town 町コード
     * @param {Number} hon 地番親番
     * @param {Number} eda 地番枝番
     * @param {function} handler 非同期検索が終了した時に呼び出されるハンドラ
     */
    searchChiban(ward, town, hon, eda, handler) {
      const url = chibanURL() + `?ward=${ward}&town=${town}&hon=${hon}&eda=${eda}`;
      dbglog(url);

      fetch(url, {
        mode: 'cors',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(data);
        if (data.length) {
          this.$store.commit('setChibans', data);
        }
        handler(data);
      })
      .catch((err) => {
        dbglog(`Address.vue.searchChiban(): ${err}`);
      });
    },
    /**
     * 入力された住所位置を中心として地図画面に遷移する
     */
    gotoMap () {
      this.loadingMap = true;
      this.$store.commit('setChibanOya', this.oyaban);
      this.$store.commit('setChibanEda', this.edaban);
      this.searchChiban(this.wardCode, this.townCode,
        this.$store.state.oyaban, this.$store.state.edaban, (data) => {
          this.loadingMap = false;
          if (data != null & data.length > 0) {
            //this.$store.commit('setCenter', { x: data[0].x, y: data[0].y });
            let x = 0;
            let y = 0;
            for (let i = 0; i < data.length; i++) {
              x += data[i].x;
              y += data[i].y;
            }
            x /= data.length;
            y /= data.length;
            this.$store.commit('setCenter', { x: x, y: y });
            this.$router.push('map');
          }
          else if (data == 401) {
            this.authDialog = true;
          }
          else {
            //this.dialogMsg = `エラーが発生しました: ${data.errorDesc}`;
            //this.dialog = true;
            this.$router.push('map');
          }
        });
    },
    /**
     * 入力された住所に一致する閲覧データを検索してリスト表示する
     */
    gotoAddrList () {
      this.$store.commit('setMode', 8);
      //this.loadingList = true;
      this.$store.commit('setChibanOya', this.oyaban);
      this.$store.commit('setChibanEda', this.edaban);
      //this.$router.push({ name: 'loading', params: { action: 3 }});
      
      this.searchDialog = true;
      this.controller = searchGaiyoByAddress(
        this.wardCode, this.townName, this.oyaban, this.edaban, (data) => {
        this.searchDialog = false;
        if (data.errorDesc !== undefined) {
          this.dialog = true;
          this.dialogCategory = 1;
          if (data.errorCode == 401) {
            //this.dialogMsg = 'ユーザ認証に失敗しました。';
            this.authDialog = true;
          }
          else {
            this.dialogMsg = `エラーが発生しました: ${data.errorDesc}`;
          }
        }
        else if (data !== null && data.length !== undefined) {
          this.$store.commit('setSummaries', data);
          this.$store.state.mode = 8;
          //this.$router.push({ name: 'kousakulistresult', params: { listId: 1 }});
          this.$router.push({ name: 'list-result', params: { listId: 1 }});
        }
        else {
          dbglog(data, -1);
        }
      });
      
    },
    cancelSearch () {
      this.controller.abort();
      this.searchDialog = false;
      this.dialogCategory = 0;
      this.dialog = true;
      this.dialogMsg = 'キャンセルされました。';
    },
    selectEdaban (flag) {
      this.edabanActive = flag;
    },
  }
}
</script>

<style lang="scss" scoped>
//@import '../styles/common/common.css';

.ges-address-page {
  background-color: #cceeee;
}
.search-btn {
  border-radius: 5px;
  border: 0px;
  background-color: #4063a3;
  margin: 10px;
  padding: 10em;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  color: #cbe7e5;
  font-size: 2.0em; //2.4em;
  user-select: none;
  width: 10em;
  height: 1.5em;
}
.search-btn-map {
  background-color: #4063a3;
}
.search-btn-addr {
  background-color: #6b3f16;
}
.chiban {
  font-size: 2rem;
  width: 50%;
  display: inline;
}
.active {
  background-color: rgb(238, 238, 163);
}
.inactive {
  background-color: white;
}
</style>